import { useEffect, useState } from "react";

// Samples the loaded logo: "blank" (one flat colour, e.g. an all-white file) or whether it has transparency.
const inspect = (img) => {
  try {
    const c = document.createElement("canvas");
    const w = (c.width = Math.min(img.naturalWidth, 96));
    const h = (c.height = Math.max(1, Math.round((img.naturalHeight / img.naturalWidth) * w)));
    const ctx = c.getContext("2d");
    ctx.drawImage(img, 0, 0, w, h);
    const d = ctx.getImageData(0, 0, w, h).data;
    let transparent = false, min = 765, max = 0, visible = 0;
    for (let i = 0; i < d.length; i += 4) {
      if (d[i + 3] < 200) { transparent = true; if (d[i + 3] < 16) continue; }
      visible += 1;
      const s = d[i] + d[i + 1] + d[i + 2];
      if (s < min) min = s;
      if (s > max) max = s;
    }
    return { blank: visible === 0 || (!transparent && max - min < 24), transparent };
  } catch {
    return { blank: false, transparent: true }; // cross-origin image: can't read pixels, keep the normal (white-on-dark) treatment
  }
};

// Shows the uploaded logo only; falls back to the showroom name if it is missing, broken or blank. Never an empty box.
export const BrandLogo = ({ src, name, imgClassName = "", imgStyle, nameClassName = "", nameStyle, testid = "brand" }) => {
  const [failed, setFailed] = useState(false);
  const [opaque, setOpaque] = useState(false);
  const [cors, setCors] = useState(true); // try a CORS load first so the pixels can be checked; retry plain if the host refuses
  useEffect(() => { setFailed(false); setOpaque(false); setCors(true); }, [src]);
  const onLoad = (e) => {
    const img = e.currentTarget;
    if (!img.naturalWidth) { setFailed(true); return; }
    const r = inspect(img);
    if (r.blank) setFailed(true);
    else setOpaque(!r.transparent);
  };
  if (src && !failed) {
    return <img key={cors ? "c" : "p"} src={src} alt={name} crossOrigin={cors && !src.startsWith("data:") ? "anonymous" : undefined} className={imgClassName} style={imgStyle}
      data-opaque={opaque ? "true" : undefined} onLoad={onLoad} onError={() => (cors ? setCors(false) : setFailed(true))} data-testid={`${testid}-logo`} />;
  }
  return <span className={nameClassName} style={nameStyle} data-testid={`${testid}-name`}>{name}</span>;
};

export const isExternalImage = (url) => {
  if (!url || url.startsWith("/") || url.startsWith("data:")) return false;
  try {
    const host = new URL(url).host;
    return host !== window.location.host && host !== new URL(process.env.REACT_APP_BACKEND_URL).host;
  } catch { return false; }
};
